<template>   
    <v-navigation-drawer 
        :value="left" 
        width="400" 
        fixed 
        temporary
    >
        <template 
            v-slot:prepend 
            class="pb-0 mb-0"
        >
            <v-card 
                tile 
                class="pb-0 mb-0"
            >
                <v-toolbar 
                    color="primary"
                >
                    <v-col 
                        cols="10" 
                        class="pb-0 mb-0 pl-1"
                    >
                        <v-autocomplete 
                            v-model="selItem" 
                            :items="listaMenu" 
                            dense 
                            class="pb-0 mb-0 mt-4" 
                            item-text="descripcion" 
                            item-value="url" 
                            solo 
                            clearable 
                            label="Buscar en todas tus aplicaciones" 
                            hide-no-data 
                        />
                    </v-col>
                    <div class="flex-grow-1" />
                    <v-btn 
                        :ripple="false" 
                        fab 
                        color="primary" 
                        depressed="" 
                        @click="closeSidebar"
                    >
                        <v-icon>mdi-apps</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
        </template>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title 
                    style="color:#0e345b" 
                    class="title text-center" 
                    color="primary"
                >
                    Mis Aplicaciones UG
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list 
            v-if="categorias.length"
            expand 
            shaped 
            class="pa-0 ma-0 pt-3"
        >
            <v-list-group 
                v-for="item in categorias" 
                :key="item.id_Categoria" 
                :filter="filter" 
                :prepend-icon="item.mui_Icono" 
                no-action
            >
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title 
                            style="color:black; letter-spacing: 1px" 
                            v-text="item.dsc_Categoria" 
                        />
                    </v-list-item-content>
                </template>

                <template v-for="subItem in listaMod">
                    <v-list-item 
                        v-if="subItem.id_Categoria === item.id_Categoria" 
                        :key="subItem.descripcion"
                        :href="subItem.url" 
                        class="pl-11" 
                        @click="()=>{}"
                    >
                        <v-list-item-action class="mr-1">
                            <v-icon 
                                color="primary" 
                                left 
                                v-text="subItem.icono_mui"
                            />
                        </v-list-item-action>
                        <v-list-item-title 
                            v-text="subItem.descripcion"
                        />
                    </v-list-item>
                </template>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import {
    mapGetters,
    mapState,
    mapActions,
    mapMutations
} from 'vuex'

export default {
    props: {
        left: {
            type: Boolean,
            required: true
        },
        closeSidebar: {
            type: Function,
            required: true
        },
        // categorias: {
        //     type: Array,
        //     required: true
        // }

    },
    data: () => ({
        selItem: null,
        listaMod:[],
        open: [1, 2],
        search: null,
        caseSensitive: false,
    }),
    computed: {
        ...mapState(['listaMenu', 'categorias']),

        filter () {
            return this.caseSensitive ?
                (item, search, textKey) => item[textKey].indexOf(search) > -1 :
                undefined
        },
    },
    watch:{
        selItem (val, oldval) {
            window.open(val, "_self");
        }
    },
    mounted () {
        /* this.obtenerCategorias().then(() => 
            this.obtenerPermisos().then(() => 
                this.listaMod = this.listaMenu
            )
        
        ) */
    },
    methods: {
        ...mapActions(['alterTablero', 'obtenerPermisos', 'obtenerCategorias']),
        go (url) {
            window.location = url
        },
        add (item) {
            this.alterTablero(item)
        }
    },
}
</script>
